export type Locale = "ru" | "en";

import { ru } from "@/locales/ru";
import { en } from "@/locales/en";

type Messages = Record<string, string>;

type LocaleMessages = Record<Locale, Messages>;

const messages: LocaleMessages = {
  ru,
  en,
};

const LOCALE_STORAGE_KEY = "app-locale";

function getStoredLocale(): Locale {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored === "ru" || stored === "en") return stored;
  } catch (_) {
    console.log("set lang error");
  }
  return "en";
}

let currentLocale: Locale = getStoredLocale();

export function setLocale(locale: Locale) {
  currentLocale = locale;
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch (_) {
    console.log("set lang error");
  }
}

export function getLocale(): Locale {
  return currentLocale;
}

export function t(key: string): string {
  const localeMessages = messages[currentLocale] || {};
  return localeMessages[key] || key;
}

export function useI18n() {
  return {
    t,
    locale: currentLocale,
    setLocale,
  };
}
